import { _, React } from '@api'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { LazyLoadMedia, PrimaryIconButton,  } from 'centric-ui-components';
import SwipeableViews from 'react-swipeable-views';
import { observable, action, observer, useLocalStore } from '@api';
import * as css from './ImageSlider.css';

export class ImageSliderStore {
  
    @observable selectedImageIndex : number = 0

    @action onClickForward = () => {
        this.selectedImageIndex++
    }

    @action onClickBackward = () => {
        this.selectedImageIndex--
    }
    handleStepChange = activeStep => {
        this.selectedImageIndex = activeStep
    }
}
  
export const ImageSliderStoreContext = React.createContext<ImageSliderStore>(null)
export const useImageSliderStore = () => React.useContext(ImageSliderStoreContext)
interface IImageSlider {
    images: Array<any> //Array<{ largeImageURL: string, hex?: string, showHex?: boolean, id: string }>
    selectedImageIndex?: number
    onClickBackward?: () => null
    onClickForward?: () => null
    handleStepChange?: () => null
}

export const ImageSlider = observer<IImageSlider>(function ImageSlider(props) {
    const store = useLocalStore(() => new ImageSliderStore())
    const { selectedImageIndex, onClickBackward, onClickForward, handleStepChange } = store
    let selectedImagePosition = props.selectedImageIndex ?? selectedImageIndex
    return (
        <ImageSliderStoreContext.Provider value={store}>
        <div className={css.root}>
           { props.images.length > 1  && selectedImageIndex > 0 && 
                <PrimaryIconButton
                icon={<KeyboardArrowLeft />}
                disabled={selectedImagePosition === 0}
                className={css.left}
                onClick={props.onClickBackward ?? onClickBackward} />
           }
            <SwipeableViews 
            index={selectedImagePosition} 
            onChangeIndex={props.handleStepChange ?? handleStepChange}
            className={css.swipeableViews}
            slideClassName={css.slide}>
                {_.map(props.images, (image, i) => {
                    const { largeImageURL, hex, showHex } = image
                    return (<div
                        key={`${image.id}_${i}`}
                        className={css.image}>
                        <LazyLoadMedia
                            isActive
                            image={largeImageURL}
                            isSelected={false}
                            hex={hex}
                            showHex={showHex}
                        />
                    </div>
                    )
                })}
            </SwipeableViews>
            {props.images.length > 1 && selectedImageIndex < (props.images.length - 1) && 
               <PrimaryIconButton
                icon={<KeyboardArrowRight />}
                disabled={selectedImagePosition === props.images.length - 1}
                className={css.right}
                onClick={props.onClickForward ?? onClickForward} />
            }
        </div>
        </ImageSliderStoreContext.Provider>
    )
})





// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/ImageSlider/ImageSlider.tsx